export default {
    report_overview_title: "Report",
    report_overview_name: "Report",
    report_overview_execute_report: "Execute Report",
    report_overview_export_report: "Export Report",
    report_overview_filters: "Filters",
    report_overview_dealer: "Dealer",
    report_overview_account: "Account",
    report_overview_customer: "Customer",
    report_overview_schedule_report: "Schedule this report",
    report_overview_creation_date_filter: "Creation Date Filter",
    report_overview_after: "After",
    report_overview_before: "Before",
    report_overview_missing: "Missing",
    report_overview_execute_error: "There was an error executing the report",
    report_overview_export_error: "There was an error exporting the report",

    report_overview_unit_status_ddl: "Unit Status",
    report_overview_unit_status_active: "Active",
    report_overview_unit_status_voluntary_suspended: "Voluntary Suspended",
    report_overview_unit_status_involuntary_suspended: "Incoluntary Suspended",
    report_overview_unit_status_cancelled: "Cancelled",
    report_overview_unit_status_rma: "RMA",
    report_overview_select_filter: "Select a filter",

    "report_overview_SIMOwner(Dealer)": "SIM Owner (Dealer)",
    report_overview_CompanyName: "Company Name",
    report_overview_AccountStatus: "Account Status",
    report_overview_IMEI: "IMEI",
    report_overview_SerialNumber: "Serial Number",
    report_overview_ShowonSite: "Show on Site",
    report_overview_SIMNumber: "SIM Number",
    report_overview_SIMPhoneNumber: "SIM Phone Number",
    report_overview_SIMStatus: "SIM Status",
    report_overview_SIMOwner: "SIM Owner",
    report_overview_Account: "Account",
    report_overview_AccountStatus: "Account Status",
    report_overview_Network: "Network",
    report_overview_Manufacturer: "Manufacturer",
    report_overview_DeviceModel: "Device Model",
    report_overview_DeviceFamily: "Device Family",
    report_overview_ESN: "ESN",
    report_overview_ICCID: "ICCID",
    report_overview_MSISDN: "MSISDN",
    report_overview_DeviceStatus: "Device Status",
    report_overview_Dealer: "Dealer",
    report_overview_Active: "Active",
    report_overview_VoluntarySuspension: "Voluntary Suspension",
    report_overview_InvoluntarySuspension: "Involuntary Suspension",
    report_overview_Cancelled: "Cancelled",
    report_overview_RMA: "RMA",
    report_overview_Label: "Label",
    report_overview_SIMProviderAccount: "SIM Provider Account",
    report_overview_UnitStatus: "Unit Status",
    report_overview_unitId: "Unit Id",
    report_overview_unitLabel: "Unit Label",
    report_overview_esn: "Serial",
    report_overview_lastMessageTime: "Last Message Time",
    report_overview_unitTime: "Unit Time",
    report_overview_serverTime: "Server Time",
    report_overview_ageHours: "Age Hours",
    report_overview_companyName: "Company",
    report_overview_mostRecentMessageTime: "Most Recent Message Time",
    report_overview_activeUnits: "Active Units",
    report_overview_offlineUnits: "Offline Units",
    report_overview_percentage: "Percentage",
    report_overview_date: "Date",
    report_overview_warning: "Warning",
    report_overview_devices: "Devices",
    report_overview_company: "Company",
    report_overview_type: "Type",
    report_overview_value: "Value",
    report_overview_label: "Name",
    report_overview_activeAccounts: "Active Accounts",
    report_overview_activeDevices: "Active Devices",
    report_overview_startDate: "Date Range",
    "Offline Days": "Offline Days",

    report_overview_fuelcard_id: "Fuelcard Id",
    report_overview_company_id: "Company Id",
    report_overview_company_name: "Company",
    report_overview_company_code: "Company Code",
    report_overview_account_code: "Account Code",
    report_overview_processor: "Processor",
    report_overview_fleet_code: "Fleet Code",
    report_overview_provider: "Provider",
    report_overview_card_number: "Card Number",
    report_overview_vehicle_id: "Vehicle Id",
    report_overview_vehicle_description: "Vehicle Description",
    report_overview_created_date: "Created Date",
    report_overview_created_at: "Created At",
    report_overview_updated_at: "Updated At",
    report_overview_transactions_count: "Transactions Count",
    SAVED: "Saved",
    INACTIVE: "Inactive",
    ACTIVE: "Active",


    report_overview_cardNumber: "Card Number",
    report_overview_siteName: "Site Name",
    report_overview_vehicleDesc: "Vehicle Description",
    report_overview_transactionDate: "Transaction Date",
    report_overview_postDate: "Post Date",
    report_overview_createdAt: "Created At",
    report_overview_updatedAt: "Updated At",
    report_overview_compId: "Company Id",
    report_overview_compName: "Company",
    report_overview_fuelcardId: "Fuelcard Id",
    report_overview_accountCode: "Account Code",
    report_overview_vehicleId: "Vehicle Id",
    report_overview_createdDate: "Created Date",
    report_overview_vehicleDescription: "Vehicle Description",
    report_overview_created: "Created",
    report_overview_companyStatus: "Company Status",

    report_overview_hasPerm: "Has Perm.",
    report_overview_fcCompanyCode: "FC Company Code",
    report_overview_numberCards: "Numbers of Cards",
    report_overview_cardLastReceivedDate: "Card Last Received Date",
    report_overview_duplicates: "Duplicates",
    report_overview_numberTrans: "Numbers of Trans.",
    report_overview_transLastReceivedDate: "Trans. Last Received Date",
    report_overview_compID: "Company Id",
    report_overview_dupCount: "Duplicate Count",
    report_overview_lastTimeCreated: "Last Time Created",
    report_overview_select_calendar: ", select the calendar and click on the apply button",
    report_overview_processedUnits: "Processed Units",
    report_overview_totalUnits: "Total Units",
    report_overview_ftpStatus: "FTP Status",
    report_overview_filesize: "Filesize",
    report_overview_dateProcessed: "Date Processed",
    report_overview_startDateTime: "Start Date",
    report_overview_endDateTime: "End Date",
    report_overview_reTry: "Re-Try",
    report_overview_activeMonths: "Active Months",
    report_overview_initialRegistration: "Initial Registration",
    report_overview_lastRegistered: "Last Registered",
    report_overview_registeredOnWaylens: "Registered On Waylens",
    report_overview_environment: "Environment",
    report_overview_lastReportEvent: "Last Report Event",
    report_overview_installed: "Installed",
    report_overview_tagId: "Tags",
    report_overview_range_message: "* Date range is only applied when you select the date range or when you have selected the date range in the past",
    report_overview_eventId: "Event Id",
    report_overview_eventName: "Event Name",
    report_overview_deviceIddr: "Device Id",
    report_overview_clipId: "Clip Id",
    report_overview_currentStatus: "Current Status",
    report_overview_createdBy: "Created By",
    report_overview_reviewedBy: "Reviewed By",
    report_overview_review_date: "Review Date",
    report_overview_event_date: "Event Date",
    report_overview_eventDate: "Event Date",
    report_overview_eventType: "Event Type",
    report_overview_dateRangeBy: "Date Range By",
    "ESN": "ESN",
    "Event Id": "Event Id",
    "Event Name": "Event Name",
    "Device Id": "Device Id",
    "Clip Id": "Clip Id",
    "Old Status": "Old Status",
    "New Status": "New Status",
    "Note": "Note"
};